// extracted by mini-css-extract-plugin
export default {"models":"ModelsTab_models__LWjgw","block":"ModelsTab_block__SJ2hM","modelSettings":"ModelsTab_modelSettings__j7vlx"};